import React, { FC, memo, useCallback, useMemo } from 'react';
import { deleteKoumuten } from '../../../api/fetch-functions/koumuten';
import { viewTexts } from '../../../constants/view-texts';
import { useToken } from '../../../global-state/auth-state';
import { fetchKoumutenList } from '../../../global-state/database/koumuten-list';
import { IKoumutenType } from '../../../types/record/koumuten';
import { ConfirmDeleteDialogTemplate } from '../confirm-delete-dialog-template/confirm-delete-dialog-template';

const vt = viewTexts.dialogs.deleteKoumuten;

interface Props {
  open: boolean;
  onClose: (reason: 'ok' | 'cancel' | '') => void;
  koumuten: IKoumutenType;
}

export const DeleteKoumutenDialog: FC<Props> = memo(
  ({ open, onClose, koumuten: koumutenInit }: Readonly<Props>) => {
    const message = useMemo<string[]>(() => vt.message(koumutenInit.name), [
      koumutenInit.name
    ]);

    /* event handler */

    const token = useToken();

    const closeOnClick = useCallback(
      (reason: 'yes' | 'no') => {
        if (reason === 'no') {
          onClose('cancel');
        } else {
          if (token !== undefined && koumutenInit.name !== undefined) {
            deleteKoumuten(token)(koumutenInit.id).then(res => {
              if (res.type === 'success') {
                onClose('ok');
                fetchKoumutenList();
              }
            });
          }
        }
      },
      [onClose, koumutenInit, token]
    );

    return (
      // TODO: 待機状態のUIを作る
      <ConfirmDeleteDialogTemplate
        title={vt.title}
        messages={message}
        open={open}
        onClose={closeOnClick}
      />
    );
  }
);

DeleteKoumutenDialog.displayName = 'DeleteKoumutenDialog';
